// extracted by mini-css-extract-plugin
export default {"title":"extraInsurance-module__title__yec-L","danger":"extraInsurance-module__danger__5Qy6Y"};